export const ImpressionCardsCarousel = (function () {
	let swiperInstance = null;
  
  function initSwiper({selectorId, isReverse}) {
    const swiperWrapper = document.querySelector(`${selectorId} .swiper-wrapper`);

    if (!swiperWrapper) {
      console.error('Required elements not found');
      return null;
    }    
    
    // Initialize Swiper
    const swiper = new Swiper(`${selectorId}.swiper`, {
      spaceBetween: 16,
      loop: true,
      slidesPerView: "auto",
      freeMode: true,
      speed: 6500,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: isReverse,
        pauseOnMouseEnter: false
      },
    });

		swiperInstance = swiper;

		return swiper;
  }

  // Public methods
  return {
    init: function({selectorId, isReverse}) {
      document.addEventListener('DOMContentLoaded', function() {
      	const swiperWrapper = document.querySelector(`${selectorId} .swiper-wrapper`);
        swiperWrapper.style.gap = '0';
        swiperWrapper.style.setProperty("transition-timing-function", "linear", "important");
      	
        // Initialize swiper
        initSwiper({selectorId, isReverse});
      });
    }
  };
})();